import { useState } from "react";
import { AiOutlineCar } from "react-icons/ai";
import VehiclePanel from "./VehiclePanel";

export default function WidgetPO({ prevOutVehicles }: any) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-200 cursor-pointer mb-2">
      <button
        onClick={() => setShowDetails(true)}
        className="py-2 px-3 flex flex-row items-center "
      >
        <div className="bg-red-100 p-4 rounded-full text-toyota">
          <AiOutlineCar size={35} />
        </div>
        <div className="flex flex-col ml-2 justify-center">
          <div className="text-sm text-gray-800 font-bold uppercase truncate">
            <span className="text-toyota">Exited</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <div className="rounded-sm text-black text-3xl font-bold">
              {prevOutVehicles?.length}
            </div>
          </div>
        </div>
      </button>

      <VehiclePanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        vehicles={prevOutVehicles}
        title={"Vehicles Exited : Previous"}
      />
    </div>
  );
}
